export interface HistoryThreadRef {
  boardSlug: string;
  threadId: string;
}

export function historyThreadKey(ref: HistoryThreadRef): string {
  return JSON.stringify([ref.boardSlug, ref.threadId]);
}

export function isHistoryThreadRef(value: unknown): value is HistoryThreadRef {
  if (typeof value !== "object" || value === null) return false;
  const ref = value as Partial<HistoryThreadRef>;
  return (
    typeof ref.boardSlug === "string" &&
    ref.boardSlug.length > 0 &&
    typeof ref.threadId === "string" &&
    ref.threadId.length > 0
  );
}
